import {
  getUbaPageName,
  openUrl,
  TrackEventUBA,
} from '@jobseeker/common-core/utils';
import {
  IimjobsLogo,
  LockPrem,
  WhiteCrossOutlined,
} from '@jobseeker/lotus/assets/icons';
import {Box, Button, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useEffect, useState} from 'react';

type LBProps = {
  title: string;
  subtitle?: string;
  cross?: boolean;
  link: string;
};
export const LinkedInBottomSheetComponent = ({
  title,
  subtitle,
  cross,
  link,
}: LBProps) => {
  const linkageName = `LinkedIn Install App Bottomsheet on ${getUbaPageName()}`;
  const linkageType = 'bottomsheetBanner';

  useEffect(() => {
    TrackEventUBA('appDownloadLinkageView', 'view', {
      page: getUbaPageName(),
      sessionUsername: sessionStorage.getItem('userId') || '',
      linkageName,
      linkageType,
    });
  }, []);
  const [open, setOpen] = useState(true);
  return cross ? (
    <Box
      sx={{
        position: 'fixed',
        bottom: 12,
        width: 'calc(100% - 32px)',
        display: open ? 'flex' : 'none',
        zIndex: 1,
      }}
    >
      <Box
        width={'100%'}
        sx={{
          background:
            'linear-gradient(279deg, #91B879 -13.38%, #49966E -13.37%);',
        }}
        display={'flex'}
        p={1.5}
        borderRadius={3}
      >
        <Box height={50} width={50}>
          <Image
            src={IimjobsLogo}
            alt={'iimjobsLogo'}
            title={'iimjobsLogo'}
            height={50}
            width={50}
          />
        </Box>

        <Box
          ml={1.5}
          display="flex"
          flexDirection={'column'}
          alignItems={'flex-start'}
          width={'100%'}
          mt={-0.25}
        >
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <Box display={'flex'} justifyContent="space-between" width="100%">
              <Typography
                variant={'subtitle2'}
                fontWeight={600}
                color="#ffffff"
                lineHeight={'21px'}
              >
                {title}
              </Typography>
              {cross && (
                <Image
                  src={WhiteCrossOutlined}
                  alt="cross"
                  width={18}
                  height={18}
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    cross && setOpen(false);
                    TrackEventUBA('appDownloadLinkageClick', 'click', {
                      page: getUbaPageName(),
                      sessionUsername: sessionStorage.getItem('userId') || '',
                      linkageName,
                      linkageType,
                      typeClick: 'Close',
                    });
                  }}
                />
              )}
            </Box>
            <Typography fontSize={'11px'} fontWeight={400} color="#ffffff">
              {subtitle}
            </Typography>
          </Box>
          <Button
            sx={{
              fontSize: '13px',
              color: '#fff',
              background: 'secondary.main',
              px: 2,
              py: 0.5,
              height: 'fit-content',
              backgroundColor: 'secondary.main',
              marginTop: '8px',
              borderRadius: 10,
              ':hover': {backgroundColor: 'secondary.main'},
            }}
            variant="contained"
            size="small"
            onClick={() => {
              TrackEventUBA('appDownloadLinkageClick', 'click', {
                page: getUbaPageName(),
                sessionUsername: sessionStorage.getItem('userId') || '',
                linkageName,
                linkageType,
                typeClick: 'CTA',
              });
              openUrl(link, '_blank');
            }}
            data-testid="install_now"
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                color: '#fff',
                fontSize: '13px',
                fontWeight: 500,
              }}
            >
              Get App{' '}
            </Box>
          </Button>
        </Box>
      </Box>
    </Box>
  ) : (
    <Box
      sx={{background: 'white'}}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      px={4}
      py={2}
      position={'absolute'}
      zIndex={10}
      mr={2}
      top={-200}
      ml={0.5}
    >
      {' '}
      <Image src={LockPrem} height={36} width={36} alt="lock" />{' '}
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          lineHeight: '21px',
          mt: 1,
        }}
      >
        {title}{' '}
      </Typography>
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 400,
          lineHeight: '20px',
          textAlign: 'center',
          color: '#7E7E7E',
          mt: 1,
        }}
      >
        {subtitle}{' '}
      </Typography>
      <Button
        sx={{
          fontSize: '13px',
          color: '#fff',
          background: 'secondary.main',
          px: 2,
          py: 0.5,
          height: 'fit-content',
          backgroundColor: 'secondary.main',
          marginTop: '13px',
          borderRadius: 10,
          ':hover': {backgroundColor: 'secondary.main'},
        }}
        variant="contained"
        size="small"
        onClick={() => {
          openUrl(link, '_blank');
          TrackEventUBA('appDownloadLinkageClick', 'click', {
            page: getUbaPageName(),
            sessionUsername: sessionStorage.getItem('userId') || '',
            linkageName,
            linkageType,
            typeClick: 'CTA',
          });
        }}
        data-testid="install_now"
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: '#fff',
            fontSize: '13px',
            fontWeight: 500,
          }}
        >
          Install Now{' '}
        </Box>
      </Button>
    </Box>
  );
};
